import { Instance, types } from 'mobx-state-tree'
const Api = types.model('Api', {
  id: types.optional(types.string, ''),
  apiId: types.optional(types.string, ''),
  appName: types.optional(types.string, ''),
  apiPurpose: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  channelId: types.optional(types.string, ''),
  apiEndPoint: types.optional(types.string, ''),
  exposedTo: types.optional(types.string, ''),
  filterType: types.optional(types.string, ''),
  apigwEndPoint: types.optional(types.string, ''),
  rateLimit: types.optional(types.string, ''),
  rateLimitAction: types.optional(types.string, ''),
  rateLimitUnits: types.optional(types.string, ''),
  createdBy: types.optional(types.string, ''),
  devSpocEmail: types.optional(types.string, ''),
  devSpocMobileNumber: types.optional(types.string, ''),
  expectedTps: types.optional(types.string, ''),
  loadTime: types.optional(types.string, ''),
  modifiedBy: types.optional(types.string, ''),
  policies: types.optional(types.string, ''),
  topsSpocEmail: types.optional(types.string, ''),
  topsSpocMobileNumber: types.optional(types.string, ''),
  isActive: types.optional(types.boolean, false),
  isSelected: types.optional(types.boolean, false),
  profileName: types.optional(types.string, ''),
})
export type ApiV2 = Instance<typeof Api>
export { Api }
